module.exports = __webpack_public_path__ + "img/fire.5d0d9823.svg";